<!---CIC horizontal starts-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="content-image-card fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img [src]="cardData?.forwarderThumbnail" (error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-row fx-start-stretch">
			<ng-container
				*ngIf="![null, undefined, ''].includes(cardData?.thumbnail) || cardData?.format || cardData?.duration">
				<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
					<div class="thumbnail-block fx-row">
						<div class="thumbnail fx-row fx-center-center" (click)="info(cardData)">
							<ng-container *ngIf="![null, undefined, ''].includes(cardData?.thumbnail)">
								<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
							</ng-container>
							<ng-container *ngIf="cardData?.format">
								<div class="format-icon fx-row fx-center-center">
									<ng-container *ngIf="cardData?.format === 'video'">
										<mat-icon svgIcon="video_camera"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'audio'">
										<mat-icon svgIcon="audio_headphone"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'page'">
										<mat-icon svgIcon="pages"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'link'">
										<mat-icon svgIcon="external_link"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'document'">
										<mat-icon svgIcon="document"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'image'">
										<mat-icon svgIcon="image_collection"></mat-icon>
									</ng-container>
								</div>
								<ng-container *ngIf="cardData?.duration">
									<div class="timer" [ngClass]="{'overlay': ![null, undefined, ''].includes(cardData?.thumbnail)}">
										<p>{{cardData?.duration}}</p>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="cardData?.read || cardData?.type || cardData?.status || cardData?.userThumbnail || cardData?.actions?.length || cardData?.title || cardData?.description || cardData?.creator || cardData?.date || cardData?.courseDuration || ![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
				<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="cardData?.type || cardData?.status || cardData?.promotion || cardData?.read">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container
								*ngIf="cardData?.type || (cardData?.read && cardData?.format && ['document', 'page', 'link'].includes(cardData?.format))">
								<div class="fx-row fx-start-center">
									<ng-container *ngIf="cardData?.type" [ngTemplateOutlet]="typePatch"
										[ngTemplateOutletContext]="{data: cardData}">
									</ng-container>
									<ng-container *ngIf="cardData?.read">
										<div class="tick-icon">
											<mat-icon svgIcon="tick_mark"></mat-icon>
										</div>
									</ng-container>
								</div>
							</ng-container>
							<div class="fx-row fx-start-center">
								<ng-container *ngIf="cardData?.status" [ngTemplateOutlet]="typePatch"
									[ngTemplateOutletContext]="{data: cardData}">
								</ng-container>
								<ng-container *ngIf="cardData?.promotion">
									<span class="hyperlink" (click)="promotion(cardData)">{{locale.translate('promote')}}</span>
								</ng-container>
								<!-- <ng-container *ngIf="cardData?.hyperRemove">
									<p (click)="close({'actionElement': actionBtn, 'data': cardData})" class="status-text hyperlink">
										{{locale.translate('remove')}}</p>
								</ng-container> -->
								<ng-container *ngIf="cardData?.removable">
									<button class="delete-btn" mat-icon-button #actionBtn
										(click)="close({'actionElement': actionBtn, 'data': cardData})">
										<mat-icon svgIcon="delete"></mat-icon>
									</button>
								</ng-container>
							</div>
						</div>
					</ng-container>
					<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="cardData?.title || cardData?.description">
							<div class="fx-column fx-start-start fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title">
									<p class="card-title linkable" (click)="info(cardData)">{{cardData?.title}}</p>
								</ng-container>
								<ng-container *ngIf="cardData?.description">
									<p class="card-description">{{cardData?.description}}</p>
								</ng-container>
							</div>
						</ng-container>
						<div class="fx-row-wrap fx-space-between-center">
							<ng-container
								*ngIf="cardData?.actions?.length || cardData?.date || cardData?.courseDuration || cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)">
								<div class="fx-row fx-start-center">
									<ng-container *ngIf="cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)">
										<div class="user-pic fx-row fx-start-center">
											<ng-container *ngIf="![null, undefined].includes(cardData?.userThumbnail)">
												<img (click)="profileInfo(cardData)" [src]="cardData?.userThumbnail" alt=""
													(error)="gfService.setErrorImage($event, 'man')">
											</ng-container>
											<span class="creator-name" (click)="profileInfo(cardData)">{{cardData?.creator}}</span>
											<ng-container *ngIf="![null,undefined].includes(cardData?.usersCount)">
												<span class="sub-caption-1" (click)="usersInfo()"> + {{cardData?.usersCount}}</span>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="cardData?.courseDuration">
										<span class="course-duration sub-txt-patch">{{cardData?.courseDuration}}</span>
									</ng-container>
									<ng-container *ngIf="cardData?.date">
										<span class="date sub-caption-1">{{cardData?.date}}</span>
									</ng-container>
									<ng-container *ngIf="cardData?.actions?.length" [ngTemplateOutlet]="actions"
										[ngTemplateOutletContext]="{data: cardData}">
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="cardData?.ratingData || cardData?.commentsCount">
								<div class="fx-row fx-start-center">
									<ng-container *ngIf="cardData?.ratingData">
										<div class="rating">
											<ng-container *ngFor="let rate of cardData?.ratingData">
												<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
													<mat-icon>star</mat-icon>
												</ng-container>
												<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
													<mat-icon>star_half</mat-icon>
												</ng-container>
												<ng-container *ngIf="rate?.value === 0">
													<mat-icon>star_border</mat-icon>
												</ng-container>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="![null, undefined].includes(cardData?.commentsCount)">
										<div>
											<ng-container *ngIf="![null, undefined].includes(cardData?.commentsCount)">
												<app-badge [count]="cardData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
													class="overview-item comments"></app-badge>
											</ng-container>
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<!-- <div *ngIf="cardData?.removable" class="cancel fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div> -->
		</div>
	</div>
</ng-container>

<ng-container *ngIf="type === 'vertical'">
	<div class="content-image-card vertical fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center fx-grow fx-shrink">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img (click)="forwarderUserInfo(cardData)" [src]="cardData?.forwarderThumbnail"
						(error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1" (click)="forwarderUserInfo(cardData)">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-column fx-start-stretch fx-grow">
			<ng-container
				*ngIf="![null, undefined, ''].includes(cardData?.thumbnail) || cardData?.format || cardData?.duration">
				<div class="thumbnail-block fx-row fx-no-grow">
					<div class="thumbnail fx-row fx-center-center cursor-pointer"
						[ngClass]="{'ratio': ![null, undefined, ''].includes(cardData?.thumbnail)}" (click)="info(cardData)">
						<ng-container *ngIf="![null, undefined, ''].includes(cardData?.thumbnail)">
							<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
						</ng-container>
						<div *ngIf="cardData?.format">
							<div class="fx-row" [ngClass]="{'img-overlay': ![null, undefined, ''].includes(cardData?.thumbnail)}">
								<div class="format-icon fx-row fx-center-center">
									<ng-container *ngIf="cardData?.format === 'video'">
										<mat-icon svgIcon="video_camera"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'audio'">
										<mat-icon svgIcon="audio_headphone"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'page'">
										<mat-icon svgIcon="pages"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'link'">
										<mat-icon svgIcon="external_link"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'document'">
										<mat-icon svgIcon="document"></mat-icon>
									</ng-container>
									<ng-container *ngIf="cardData?.format === 'image'">
										<mat-icon svgIcon="image_collection"></mat-icon>
									</ng-container>
								</div>
								<ng-container *ngIf="cardData?.duration">
									<div class="timer" [ngClass]="{'overlay': ![null, undefined, ''].includes(cardData?.thumbnail)}">
										<p>{{cardData?.duration}}</p>
									</div>
								</ng-container>
							</div>
							<!-- </ng-container> -->
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="cardData?.type || cardData?.status || cardData?.userThumbnail || cardData?.actions?.length || cardData?.title || cardData?.description || cardData?.creator || cardData?.date || cardData?.courseDuration || ![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
				<div class="content-block  fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="(cardData?.type || cardData?.status)">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container
								*ngIf="cardData?.type || (cardData?.read && cardData?.format && ['document', 'page', 'link'].includes(cardData?.format))">
								<div class="fx-row fx-start-center">
									<ng-container *ngIf="cardData?.type" [ngTemplateOutlet]="typePatch"
										[ngTemplateOutletContext]="{data: cardData}">
									</ng-container>
									<ng-container *ngIf="cardData?.read">
										<div class="tick-icon">
											<mat-icon svgIcon="tick_mark"></mat-icon>
										</div>
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="cardData?.status" [ngTemplateOutlet]="statusPatch"
								[ngTemplateOutletContext]="{data: cardData}">
							</ng-container>
							<ng-container *ngIf="cardData?.promotion">
								<p (click)="promotion(cardData)" class="status-text hyperlink">{{locale.translate('promote')}}</p>
							</ng-container>
							<!-- <ng-container *ngIf="cardData?.hyperRemove">
								<p (click)="close({'actionElement': actionBtn, 'data': cardData})" class="status-text hyperlink">
									{{locale.translate('remove')}}</p>
							</ng-container> -->
							<!-- <ng-container *ngIf="cardData?.removable">
								<button class="delete-btn" mat-icon-button #actionBtn
									(click)="close({'actionElement': actionBtn, 'data': cardData})">
									<mat-icon svgIcon="delete"></mat-icon>
								</button>
							</ng-container> -->
						</div>
					</ng-container>
					<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
						<div class="fx-row fx-start-center">
							<ng-container *ngIf="cardData?.title || cardData?.status || cardData?.actions?.length">
								<ng-container *ngIf="cardData?.title">
									<p class="card-title linkable" *ngIf="cardData?.title" (click)="info(cardData)">
										{{cardData?.title}}
									</p>
								</ng-container>
							</ng-container>
						</div>
						<ng-container
							*ngIf="![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount) || cardData?.date || cardData?.courseDuration || cardData?.creator">
							<div class="fx-column fx-space-between-stretch fx-grow fx-shrink">
								<ng-container
									*ngIf="cardData?.creator || cardData?.date || cardData?.courseDuration || cardData?.courseDuration || ![null, undefined].includes(cardData?.userThumbnail) || cardData?.actions?.length">
									<div class="user-block fx-row-wrap"
										[ngClass]="(((cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)) && cardData?.courseDuration) || ((cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)) && cardData?.date) || (cardData?.courseDuration && cardData?.date)) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)">
											<div class="fx-row fx-start-center cursor-pointer">
												<!-- <ng-container *ngIf="![null, undefined].includes(cardData?.userThumbnail)"> -->
												<div class="user-pic" (click)="profileInfo(cardData)">
													<img [src]="cardData?.userThumbnail" alt="" (error)="gfService.setErrorImage($event, 'man')">
												</div>
												<!-- </ng-container> -->
												<span class="sub-caption-1" (click)="profileInfo(cardData)">{{cardData?.creator}}</span>
												<ng-container *ngIf="![null,undefined].includes(cardData?.usersCount)">
													<span class="sub-caption-1" (click)="usersInfo()"> + {{cardData?.usersCount}}</span>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="cardData?.courseDuration">
											<span class="course-duration sub-txt-patch">{{cardData?.courseDuration}}</span>
										</ng-container>
										<ng-container *ngIf="cardData?.date">
											<span class="date sub-caption-1">{{cardData?.date}}</span>
										</ng-container>
									</div>
								</ng-container>
								<ng-container
									*ngIf="![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
									<div class="fx-row-wrap"
										[ngClass]="((![null, undefined].includes(cardData?.rating) && ![null, undefined].includes(cardData?.commentsCount))) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="![null, undefined].includes(cardData?.rating)">
											<div class="rating fx-row fx-start-center">
												<ng-container *ngFor="let rate of cardData?.ratingData">
													<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
														<mat-icon>star</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
														<mat-icon>star_half</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.value === 0">
														<mat-icon>star_border</mat-icon>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="![null, undefined].includes(cardData?.commentsCount)">
											<app-badge [count]="cardData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
												class="overview-item comments"></app-badge>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<div *ngIf="cardData?.removable" class="cancel fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="type === 'minimal'">
	<div class="content-image-card minimal fx-column fx-start-stretch">
		<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.thumbnail) || cardData?.format">
					<div class="minimal-thumbnail-block">
						<div class="minimal-thumbnail" (click)="info(cardData)">
							<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')">
							<ng-container *ngIf="cardData?.format">
								<div class="img-overlay fx-row fx-center-center">
									<div class="format-icon fx-row fx-center-center">
										<ng-container *ngIf="cardData?.format === 'video'">
											<mat-icon svgIcon="video_camera"></mat-icon>
										</ng-container>
										<ng-container *ngIf="cardData?.format === 'audio'">
											<mat-icon svgIcon="audio_headphone"></mat-icon>
										</ng-container>
										<ng-container *ngIf="cardData?.format === 'page'">
											<mat-icon svgIcon="pages"></mat-icon>
										</ng-container>
										<ng-container *ngIf="cardData?.format === 'link'">
											<mat-icon svgIcon="external_link"></mat-icon>
										</ng-container>
										<ng-container *ngIf="cardData?.format === 'document'">
											<mat-icon svgIcon="document"></mat-icon>
										</ng-container>
										<ng-container *ngIf="cardData?.format === 'image'">
											<mat-icon svgIcon="image_collection"></mat-icon>
										</ng-container>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="cardData?.type || cardData?.title">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="cardData?.type">
							<div class="patch-block fx-row fx-space-between-center">
								<ng-container *ngIf="cardData?.type">
									<div class="fx-row fx-start-center">
										<ng-container *ngIf="cardData?.type" [ngTemplateOutlet]="typePatch"
											[ngTemplateOutletContext]="{data: cardData}">
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<ng-container *ngIf="cardData?.title">
								<div class="fx-column fx-start-start fx-grow fx-shrink">
									<ng-container *ngIf="cardData?.title">
										<p class="card-title linkable" (click)="info(cardData)">{{cardData?.title}}</p>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="cardData?.removable" class="fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>


<ng-template #typePatch let-data="data">
	<div class="content-type">
		<div class="patch sub-txt-patch">{{data?.type}}</div>
	</div>
</ng-template>
<!-- <ng-template #readPatch let-data="data">
	<div class="content-type">
		<div class="patch sub-txt-patch success no-cap">
			<ng-container *ngIf="['page', 'link'].includes(cardData?.format)">
				{{locale.translate('you_have_seen_this')}}
			</ng-container>
			<ng-container *ngIf="['video', 'audio'].includes(cardData?.format)">
				{{locale.translate('you_have_watched_this')}}
			</ng-container>
			<ng-container *ngIf="['document'].includes(cardData?.format)">
				{{locale.translate('you_have_read_this')}}
			</ng-container>
		</div>
	</div>
</ng-template> -->
<ng-template #statusPatch let-data="data">
	<p class="sub-txt-patch warn">{{data?.status}}</p>
</ng-template>
<ng-template #actions let-data="data">
	<div class="button-block fx-row" [ngClass]="type === 'horizontal' ? 'fx-start-center' : 'fx-center-center'">
		<ng-container *ngFor="let action of data?.actions">
			<button mat-button class="sub-action-btn-2" type="button" #actionEl [ngClass]="action?.classes"
				(click)="actionInfo({actionEl: actionEl, action: action})">
				{{action?.caption}}
			</button>
		</ng-container>
	</div>
</ng-template>
